const menuButton = document.querySelector('.menu-toggle');
const navigation = document.querySelector('.nav');
const mobileMenu = window.matchMedia('(max-width: 850px)');
const navigationDropdowns = [...(navigation?.querySelectorAll('.nav-dropdown') || [])];

function closeNavigationDropdowns(except = null) {
  navigationDropdowns.forEach(dropdown => {
    if (dropdown !== except) dropdown.open = false;
  });
}

function setMenu(open) {
  if (!menuButton || !navigation) return;
  const isOpen = Boolean(open) && mobileMenu.matches;
  if (!isOpen) closeNavigationDropdowns();
  navigation.classList.toggle('open', isOpen);
  navigation.inert = mobileMenu.matches && !isOpen;
  menuButton.setAttribute('aria-expanded', String(isOpen));
  menuButton.setAttribute('aria-label', isOpen ? 'Menu sluiten' : 'Menu openen');
  document.body.classList.toggle('menu-open', isOpen);
  if (isOpen) navigation.style.setProperty('--menu-height', `${window.innerHeight}px`);
  if (isOpen) navigation.querySelector('a')?.focus();
}

menuButton?.addEventListener('click', () => {
  setMenu(menuButton.getAttribute('aria-expanded') !== 'true');
});

navigationDropdowns.forEach(dropdown => {
  dropdown.addEventListener('toggle', () => {
    if (dropdown.open) closeNavigationDropdowns(dropdown);
  });
});

navigation?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
  closeNavigationDropdowns();
  setMenu(false);
}));

document.addEventListener('pointerdown', event => {
  if (!navigation?.contains(event.target)) closeNavigationDropdowns();
});

document.addEventListener('keydown', event => {
  const openDropdown = navigationDropdowns.find(dropdown => dropdown.open);
  if (event.key === 'Tab' && mobileMenu.matches && navigation.classList.contains('open')) {
    const focusable = [menuButton, ...navigation.querySelectorAll('a, summary')].filter(element => element.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  if (event.key === 'Escape' && openDropdown && !mobileMenu.matches) {
    openDropdown.open = false;
    openDropdown.querySelector('summary')?.focus();
    event.preventDefault();
    return;
  }
  if (event.key === 'Escape' && menuButton?.getAttribute('aria-expanded') === 'true') {
    setMenu(false);
    menuButton.focus();
  }
});
mobileMenu.addEventListener('change', () => setMenu(false));
setMenu(false);

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.reveal').forEach(element => observer.observe(element));
const year = document.getElementById('year'); if (year) year.textContent = new Date().getFullYear();

document.querySelectorAll('.article-toc').forEach(toc => {
  const article = toc.parentElement?.querySelector('.article-content');
  const headings = [...(article?.querySelectorAll('h2') || [])];
  if (headings.length < 3) return;
  const list = toc.querySelector('ol');
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `onderdeel-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    item.append(link);
    list.append(item);
  });
  toc.hidden = false;
  // Op een telefoon staat de inhoudsopgave dicht, zodat het antwoord eerst komt.
  if (window.matchMedia('(max-width: 700px)').matches) toc.querySelector('details')?.removeAttribute('open');
});

// Leesvoortgang: hoe ver de lezer in de artikeltekst is.
const progressBar = document.querySelector('[data-reading-progress]');
const progressContent = document.querySelector('.article-content');
if (progressBar && progressContent) {
  let ticking = false;
  const update = () => {
    const box = progressContent.getBoundingClientRect();
    const total = box.height - window.innerHeight * 0.6;
    const ratio = total > 0 ? Math.min(1, Math.max(0, -box.top / total)) : 1;
    progressBar.style.transform = `scaleX(${ratio})`;
    ticking = false;
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  update();
}

// Brede tabellen in artikelen zijn scrolbaar en dus ook met het toetsenbord bereikbaar.
document.querySelectorAll('.rte table').forEach(table => {
  if (table.scrollWidth > table.clientWidth) { table.tabIndex = 0; table.setAttribute('role', 'region'); table.setAttribute('aria-label', 'Tabel, scroll horizontaal'); }
});
